export default {"src":"/_next/static/media/next.1b3eb015.svg","height":200,"width":200};